import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "../components/Container";
import Navbar from "../components/Navbar";

export default function PageNotFound() {
  useEffect(() => {
    document.title = "404";
  });
  return (
    <>
      <Navbar />
      <Container>
        <div className="w-full p-8">
          <h2 className="text-4xl text-center font-bold">404</h2>
          <h4 className="text-xl text-center">Page not found!</h4>
          <Link to="/" className="text-center block text-indigo-500">
            Go to Homepage <i className="fas fa-home"></i>
          </Link>
        </div>
      </Container>
    </>
  );
}
